/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Menu_Campaigns_DescInputs */



/**
* | output |
* | --- |
* | "Giveaways with entry rules and measured results" |
*
* @param {Products_Menu_Campaigns_DescInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_menu_campaigns_desc = /** @type {((inputs?: Products_Menu_Campaigns_DescInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Menu_Campaigns_DescInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Розыгрыши с условиями участия и измеренным результатом")
	return /** @type {LocalizedString} */ ("Giveaways with entry rules and measured results")
});